<template>
    <v-container>
        <BaseCard>
            <VCardText>
                <VForm ref="form" v-model="valid" lazy-validation v-if="searchuser">
                    <v-text-field
                            label="Search User"
                            v-model="email"
                            clearable
                            :loading="loading"
                            outlined
                            :rules="[$store.state.rules.emailRules]"
                            hint="Required - Can be changed at any time"
                            :append-outer-icon="$store.state.icons.search"
                            @click:append-outer="searchUser"
                    ></v-text-field>
                    <div v-if="error">
                                <span class="warning--text subtitle-1">
                                   {{error.message}}
                                </span>
                    </div>
                </VForm>

                <!--<p>Create user and send invite?-->
                <!--<BaseBtn @click="sendInvitetoUser()">Create</BaseBtn>-->
                <!--</p>-->

                <v-list two-line>
                    <v-list-item v-for="(u,i) in org.users" :key="i" @click="open(u)">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{u.email}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{u.permissions.toString()}}
                                <span v-if="org.owner.sub===u.sub" class="success--text">Owner </span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action >
                            <v-btn icon>
                                <v-icon>
                                    {{$store.state.icons.account}}
                                </v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>

            </VCardText>
            <VCardActions>

                <v-spacer></v-spacer>
                <BaseBtn @click="searchuser=!searchuser" retain-focus-on-click >
                    <span v-if="!searchuser">Add User</span>
                    <span v-else>Cancel</span>
                </BaseBtn>
            </VCardActions>
            <VDialog v-model="createandinvitedialog" max-width="400" persistent>
                <VCard>
                    <VCardTitle>
                        User does not exist
                        <v-spacer></v-spacer>
                    </VCardTitle>
                    <VCardText>
                        <p class="font-weight-medium subtitle-1">
                            Would you like us to invite
                            <span class="teal--text">{{email}}</span>
                            to join and edit {{org.info.fullname}} ?<br/>
                            <span>(you can set permission levels or revoke at any time)</span>
                        </p>
                    </VCardText>
                    <VCardActions>
                        <BaseBtn text @click="createandinvitedialog=false,inviting=false,email='',searchuser=false">
                            <CardCloser />
                            cancel
                        </BaseBtn>
                        <v-spacer></v-spacer>
                        <BaseBtn @click="createAndInviteUser" :loading="inviting">Yes! Invite</BaseBtn>
                    </VCardActions>
                </VCard>
            </VDialog>
            <VDialog v-model="inviteuserdialog" max-width="400" persistent>
                <VCard>
                    <VCardTitle>
                        User found
                        <v-spacer></v-spacer>
                    </VCardTitle>
                    <VCardText>
                        <p class="font-weight-medium subtitle-1">
                            Would you like to add
                            <span class="teal--text">{{email}}</span>
                            as editor to {{org.info.fullname}} ?<br/>
                            <span>(you can set permission levels)</span>
                        </p>
                    </VCardText>
                    <VCardActions>
                        <BaseBtn text @click="inviteuserdialog=false,inviting=false">
                            <CardCloser />
                            cancel
                        </BaseBtn>
                        <v-spacer></v-spacer>
                        <BaseBtn @click="sendInvitetoUser" :loading="inviting">Yes! Invite</BaseBtn>
                    </VCardActions>
                </VCard>
            </VDialog>
            <VDialog v-model="userpermissionsdialog" max-width="400" persistent>
                <VCard>
                    <VCardTitle>
                        User {{user.email}}
                    </VCardTitle>
                    <VCardText v-if="user.permissions">
                        <v-checkbox v-for="p in model"
                                    v-model="permissions"
                                    :readonly="readonly"
                                    :label="p" :value="p" :key="`${user.sub}-${p}`"></v-checkbox>
                    </VCardText>
                    <VCardActions>
                        <BaseBtn @click="userpermissionsdialog=false,user=false,permissions=false">Cancel</BaseBtn>
                        <v-spacer></v-spacer>
                        <BaseBtn :loading="loading" @click="savePermissions()">Save</BaseBtn>
                    </VCardActions>
                </VCard>
            </VDialog>
        </BaseCard>
    </v-container>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import BaseBtn from "../BaseBtn";
  import CardCloser from "../CardCloser";
  export default {
    components: { CardCloser, BaseBtn},
    name: "OrgStaff",
    computed:{
      ...mapState(['org','icons','cognito']),
    },
    data() {
      return {
        searchuser:false,
        valid:undefined,
        email:'',
        user:false,
        loading:false,
        error:false,
        createandinvitedialog:false,
        inviteuserdialog:false,
        inviting:false,
        userpermissions:false,
        userpermissionsdialog:false,
        permissions:[],
        model:['users', 'groups', 'send','financial', 'events', 'a4l'],
        readonly:false
      }
    },
    mounted() {
    },
    watch:{
      user(n,o){
        this.readonly=false
        this.permissions = this.user.permissions
        if(!n)return;
        if (n.permissions.includes('*') ){this.permissions=this.model;this.readonly=true}
      }
    },
    methods: {
      ...mapActions(['post','putAppOrg']),
      searchUser(){
        let em = this;
        if(!this.$refs.form.validate()) {
          return em.error = {message: 'E-mail must be valid'}
        } else {
          em.error = false
        }
        this.loading=true;
        let args;
        args = {
          url:this.$store.state.url + 'api/orgs/searchuser',
          method:"POST",
          data:{
            email:this.email
          }
        }
        this.$store.dispatch('fetch',args).then(res=>{
          em.loading=false
          console.log(res)
          if(res.error){
            em.error = res.error
            if(res.error.code==='UserNotFoundException'){
              em.createandinvitedialog = true
            }
          } else {
            em.user = res.user
            em.loading=false
            em.inviteuserdialog=true
          }
        }).catch(e=>{
          em.loading=false
          em.$store.commit('setSnackbar',{
            type: 'warning',
            msg: e.message,
            timeout:5000
          })
        })
      },
      async sendInvitetoUser(){
        let em = this;
        this.inviting=true;
        let data={
          identitypool:this.$store.state.idpool,
          user:this.user,
          email:this.email.trim(),
          orgname: this.org.info.fullname,
          orgkey: this.org.partkey
        }
        let u = await this.post({path:'api/orgs/inviteuser',body:data})
        this.inviting=false
      },
      createAndInviteUser(){
        let em = this;
        this.inviting=true;
        let args;
        args = {
          url:this.$store.state.url + 'api/orgs/createandinviteuser',
          method:"POST",
          data:{
            identitypool:this.$store.state.idpool,
            user:this.user,
            email:this.email,
            orgname: this.org.info.fullname,
            orgkey: this.org.partkey
          }
        }
        this.$store.dispatch('fetch',args).then(res=>{
          em.inviting=false
          em.createandinvitedialog=false
          em.inviteuserdialog=false
          em.error=false
          em.$store.dispatch('getAppData')
          if(res.error){
            em.error = res.error
          } else {
            em.$store.commit('setSnackbar',{
              type: 'success',
              msg: 'Invitation has been sent to '+ em.email,
              timeout:5000
            })
            em.email=''
            em.user = res.user
            em.inviting=false
          }
        }).catch(e=>{
          em.inviting=false
          em.$store.commit('setSnackbar',{
            type: 'warning',
            msg: e.message,
            timeout:5000
          })
        })
      },
      open(e){
        this.user = e
        this.userpermissionsdialog=true
      },
      async savePermissions(){
        this.loading=true
        let data = {
          user:this.user,
          permissions:this.permissions
        }
        let res = await this.post({path:'api/orgs/setpermissions',body:data})
        console.log(res)
        this.loading=false
        if(res.error)return
        this.userpermissionsdialog=false
        this.putAppOrg(res)
      }
    }
  }
</script>

<style scoped>

</style>